module.exports = __webpack_public_path__ + "static/img/img03@2x.d1312c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/img03@2x.png
// module id = mC9t
// module chunks = 174